import { HTTPAPIConfig } from './http-api.config';
/**
 * will have all the api config mapping for the project
 */
export const APIConfigMapping: {
  [key: string]: HTTPAPIConfig
} = {
  GET_STATIONS: {
    method: 'get',
    apiKeyName: 'GET_STATIONS',
  },

  GET_STATION_BY_ID: {
    method: 'get',
    apiKeyName: 'GET_STATION_BY_ID',
  },

  ADD_STATION: {
    method: 'post',
    apiKeyName: 'ADD_STATION',
  },

  UPLOAD_SIP_AND_GRADIENT: {
    method: 'multipart',
    apiKeyName: 'UPLOAD_SIP_AND_GRADIENT',
  },
  GET_PROCESSING_STATUS: {
    method: 'post',
    apiKeyName: 'GET_PROCESSING_STATUS',
  },

  GET_TRACKS: {
    method: 'get',
    apiKeyName: 'GET_TRACKS',
  },

  ADD_TRACK: {
    method: 'post',
    apiKeyName: 'ADD_TRACK',
  },

  ADD_STATION_SURVERY: {
    method: 'post',
    apiKeyName: 'ADD_STATION_SURVERY',
  }, 
  FETCH_SURVEY_META_FILES: {
    method: 'post',
    apiKeyName: 'FETCH_SURVEY_META_FILES',
  }, 
  GET_PIM_SIP_FILE: {
    method: 'post',
    apiKeyName: 'GET_PIM_SIP_FILE',
  },
  GET_PIM_GRADIENT_FILE: {
    method: 'post',
    apiKeyName: 'GET_PIM_GRADIENT_FILE',
  },
  POST_EDIT_TABLE_DATA: {
    method: 'multipart',
    apiKeyName: 'POST_EDIT_TABLE_DATA'
  },
  GET_PIM_SIGNALLING_FILE: {
    method: 'post',
    apiKeyName: 'GET_PIM_SIGNALLING_FILE'
  },
  GET_CHILD_ROLE_USERS: {
    method: 'get',
    apiKeyName: 'GET_CHILD_ROLE_USERS',
    urlString:'USERMGMT_API'
  },
  GET_PARENT_ROLE_USERS: {
    method: 'get',
    apiKeyName: 'GET_PARENT_ROLE_USERS',
    urlString:'USERMGMT_API'
  },
  GET_SAME_ROLE_USERS: {
    method: 'get',
    apiKeyName: 'GET_SAME_ROLE_USERS',
    urlString:'USERMGMT_API'
  },
  UPDATE_STATION_STATUS: {
    method: 'post',
    apiKeyName: 'UPDATE_STATION_STATUS'
  },
  GET_STATION_VERSIONS: {
    method: 'post',
    apiKeyName: 'GET_STATION_VERSIONS',
  },
  GET_STATION_VERSION_FILE: {
    method: 'post',
    apiKeyName: 'GET_STATION_VERSION_FILE',
  },
  GET_ALL_SELECTED_STATIONS_FILES: {
    method: 'post',
    apiKeyName: 'GET_ALL_SELECTED_STATIONS_FILES',
  },
    ADD_SIGN_TOC: {
    method: 'multipart',
    apiKeyName: 'ADD_SIGN_TOC',
  },
    ADD_SIGN_TRACK_PROFILE_DATA: {
    method: 'multipart',
    apiKeyName: 'ADD_SIGN_TRACK_PROFILE_DATA',
  },
    ADD_SIGN_TINS_PDF: {
    method: 'multipart',
    apiKeyName: 'ADD_SIGN_TINS_PDF',
  },
    ADD_SIGN_RADIO_PDF: {
    method: 'multipart',
    apiKeyName: 'ADD_SIGN_RADIO_PDF',
  },
    ADD_SIGN_RFID_TAG_DATA: {
    method: 'multipart',
    apiKeyName: 'ADD_SIGN_RFID_TAG_DATA',
  },

  PLOT_OR_UPDATE_SIP: {
    method: 'post',
    apiKeyName: 'PLOT_OR_UPDATE_SIP'
  },
  RENAME_BERTHING_TRACK_CIRCUITS: {
    method: 'post',
    apiKeyName: 'RENAME_BERTHING_TRACK_CIRCUITS'
  },
  GENERATE_COMMENTS: {
    method: 'post',
    apiKeyName: 'GENERATE_COMMENTS'
  },


  // comments
 GET_COMMENTS: {
    method: 'post',
    apiKeyName: 'GET_COMMENTS',
  },
  ADD_COMMENT: {
    method: 'post',
    apiKeyName: 'ADD_COMMENT', 
  },
  UPDATE_COMMENT: {
    method: 'post',
    apiKeyName: 'UPDATE_COMMENT',
  },
  DELETE_COMMENT: {
    method: 'post',
    apiKeyName: 'DELETE_COMMENT',
  },
  ADD_REPLY: {
    method: 'post',
    apiKeyName: 'ADD_REPLY',
  },
  ADD_STATION_DATA: {
    method: 'post',
    apiKeyName: 'ADD_STATION_DATA',
  },
  GET_OEM_RULES: {
    method:'get',
    apiKeyName:'GET_OEM_RULES',
    urlString:'PROJ_API_URL'
  },
  GET_ALL_ZONES: {
    method: 'get',
    apiKeyName: 'GET_ALL_ZONES',
    urlString:'PROJ_API_URL'
  },
  GET_ZONE_RULES_TABLE: {
    method: 'post',
    apiKeyName: 'GET_ZONE_RULES_TABLE',
    urlString:'PROJ_API_URL'
  },
  GET_RULE_TYPES: {
    method: 'get',
    apiKeyName: 'GET_RULE_TYPES',
    urlString:'PROJ_API_URL'
  },
  ADD_RULE_TYPES: {
    method: 'post',
    apiKeyName: 'GET_RULE_TYPES',
    urlString: 'PROJ_API_URL'
  },
  GET_RULE_CATEGORIES: {
    method: 'get',
    apiKeyName: 'GET_RULE_CATEGORIES',
    urlString:'PROJ_API_URL'
  },
  ADD_RULE_CATEGORY: {
    method:'post',
    apiKeyName:'GET_RULE_CATEGORIES',
    urlString:'PROJ_API_URL'
  },
  UPDATE_RULE: {
    method: 'put',
    apiKeyName:'UPDATE_RULE',
    urlString:'PROJ_API_URL'
  },
  ADD_RULE:{
    method:'post',
    apiKeyName:'UPDATE_RULE',
    urlString:'PROJ_API_URL'
  },
  DELETE_RULE: {
    method: 'delete',
    apiKeyName: 'DELETE_RULE',
    urlString: 'PROJ_API_URL'
  },
  GET_SUB_TRACKS: {
    method: 'get',
    apiKeyName: 'GET_SUB_TRACKS',
  },
  ADD_SUB_TRACK: {
    method: 'post',
    apiKeyName: 'ADD_SUB_TRACK',
  },
  SAVE_SUB_TRACK_DATA: {
    method: 'post',
    apiKeyName: 'SAVE_SUB_TRACK_DATA',
  },
  SAVE_SURVEY_DRAFT: {
    method: 'post',
    apiKeyName: 'SAVE_SURVEY_DRAFT',
  },
  UPLOAD_CAD_FILE: {
    method: 'multipart',
    apiKeyName: 'UPLOAD_CAD_FILE',
    urlString: 'EXTRACTION_API'
  },
  SAVE_ASSETS: {
    method: 'post',
    apiKeyName: 'SAVE_ASSETS',
    urlString: 'EXTRACTION_API'
  },
  PROCESS_SURVEY_FILE_FIRST_PASS: {
    method: 'multipart',
    apiKeyName: 'PROCESS_SURVEY_FILE_FIRST_PASS',
    // urlString: 'MAHESH_API_ULR'
  },
  PROCESS_SURVEY_FILE_SECOND_PASS: {
    method: 'multipart',
    apiKeyName: 'PROCESS_SURVEY_FILE_SECOND_PASS',
  },
    // urlString: 'MAHESH_API_ULR'
  GET_LAYOUT_EDIT_STATUS: {
    method: 'get',
    apiKeyName: 'GET_LAYOUT_EDIT_STATUS',
  },
  UPDATE_LAYOUT_EDIT_STATUS: {
    method: 'post',
    apiKeyName: 'UPDATE_LAYOUT_EDIT_STATUS',
  },
  UPDATE_DRAFT_ACCESS_STATUS: {
    method: 'post',
    apiKeyName: 'UPDATE_DRAFT_ACCESS_STATUS',
  },
  GENERATE_TOC_DOC: {
    method: 'post',
    apiKeyName: 'GENERATE_TOC_DOC',
    options: {
      responseType: 'blob'
    }
  },
  GENERATE_TPT_DOC: {
    method: 'post',
    apiKeyName: 'GENERATE_TPT_DOC',
    options: {
      responseType: 'blob'
    }
  },
  GET_ZONE_LIST: {
    method: 'post',
    apiKeyName: 'GET_ZONE_LIST'
  },
  GET_VENDOR_LIST: {
    method: 'post',
    apiKeyName: 'GET_VENDOR_LIST'
  },
  GET_TOC_STATION_LIST: {
    method: 'post',
    apiKeyName: 'GET_TOC_STATION_LIST'
  },
  GET_HEADER_TYPES: {
    method: 'post',
    apiKeyName: 'GET_HEADER_TYPES'
  },
  CREATE_OR_UPDATE_TOC_HEADER: {
    method: 'post',
    apiKeyName: 'CREATE_OR_UPDATE_TOC_HEADER'
  },
  GET_TOC_HEADER_DATA: {
    method: 'post',
    apiKeyName: 'GET_TOC_HEADER_DATA'
  },
  CONVERT_TOC_HEADER_EXCEL: {
    method: 'multipart',
    apiKeyName: 'CONVERT_TOC_HEADER_EXCEL'
  },
  UPDATE_SIGNALLING_TOC_DATA: {
    method: 'post',
    apiKeyName: 'UPDATE_SIGNALLING_TOC_DATA'
  },
  LOCK_STATION_LAYOUT: {
    method: 'post',
    apiKeyName: 'LOCK_STATION_LAYOUT',
  },
  UNLOCK_STATION_LAYOUT: {
    method: 'post',
    apiKeyName: 'UNLOCK_STATION_LAYOUT',
  },
  REFRESH_STATION_LAYOUT_LOCK: {
    method: 'post',
    apiKeyName: 'REFRESH_STATION_LAYOUT_LOCK',
  },
  GET_DB_FILE_DOWNLOAD: {
    method: 'get',
    apiKeyName: 'GET_DB_FILE_DOWNLOAD'
  },
  GET_TOC_CHEAT_SHEET_PDF: {
    method: 'get',
    apiKeyName: 'GET_TOC_CHEAT_SHEET_PDF'
  },
  COPY_SURVEY_DRAFT: {
    method: 'post',
    apiKeyName: 'COPY_SURVEY_DRAFT',
  },
  EXTRACT_PSR_EXCEL: {
    method: 'multipart',
    apiKeyName: 'EXTRACT_PSR_EXCEL'
  },
  ON_GRADIENT_FILE_UPLOAD: {
    method: 'multipart',
    apiKeyName: 'ON_GRADIENT_FILE_UPLOAD'
  },
  GET_ALL_TAG_DATA: {
    method: 'get',
    apiKeyName: 'GET_ALL_TAG_DATA'
  },
  GET_STATION_IP_ADDRESS: {
    method: 'get',
    apiKeyName: 'GET_STATION_IP_ADDRESS'
  },
  ZONE_VENDOR_TYPE_DELETE: {
    method: 'delete',
    apiKeyName: 'ZONE_VENDOR_TYPE_DELETE',
    postData: {}
  },
  GET_ZONES: {
    method: 'get',
    apiKeyName: 'GET_ZONES',
  },
  GET_DIVISIONS: {
    method: 'post',
    apiKeyName: 'GET_DIVISIONS',
  },
  GET_STATIONS_LIST: {
    method: 'post',
    apiKeyName: 'GET_STATIONS_LIST',
  },

  DELETE_STATION_MASTER_DATA:{
    method: 'post',
    apiKeyName: 'DELETE_STATION_MASTER_DATA'
  },
  GET_TRACK_WITH_ADJUSTMENT: {
    method: 'post',
    apiKeyName: 'GET_TRACK_WITH_ADJUSTMENT',
    postData: {}
  },
  SLF_CTF_FILE_UPLOAD: {
    method: 'multipart',
    apiKeyName: 'SLF_CTF_FILE_UPLOAD'
  },
  GET_SLF_CTF_FILES_DATA: {
    method: 'get',
    apiKeyName: 'GET_SLF_CTF_FILES_DATA'
  },
  GENERATE_DRAWING_SLF_FILE: {
    method: 'post',
    apiKeyName: 'GENERATE_DRAWING_SLF_FILE'
  },
   GENERATE_NMS_SLF_FILE: {
    method: 'post',
    apiKeyName: 'GENERATE_NMS_SLF_FILE'
  },
  GET_DRAWING_SLF_FILE: {
    method: 'get',
    apiKeyName: 'GET_DRAWING_SLF_FILE'
  },
  GAP_INTERVAL_ANALYZER: {
    method: 'post',
    apiKeyName: 'GAP_INTERVAL_ANALYZER'
  },
  GET_LAYOUT_VERSIONS: {
    method: 'post',
    apiKeyName: 'GET_LAYOUT_VERSIONS'
  },
  GET_LAYOUT_VERSION_DATA: {
    method: 'post',
    apiKeyName: 'GET_LAYOUT_VERSION_DATA'
  },
  GET_LAYOUT_SUBMISSION_STATUS: {
    method: 'get',
    apiKeyName: 'GET_LAYOUT_SUBMISSION_STATUS'
  },

  APPLY_ANTI_COLLISION_ON_RED_AND_GREEN_DATA: {
    method: 'multipart',
    apiKeyName: 'APPLY_ANTI_COLLISION_ON_RED_AND_GREEN_DATA'
  },
  APPLY_ANTI_COLLISION_PREVIEW: {
    method: 'multipart',
    apiKeyName: 'APPLY_ANTI_COLLISION_PREVIEW'
  },
  //symbology 
  GET_SYMBOLOGY_LIST: {
    method: 'get',
    apiKeyName: 'GET_SYMBOLOGY_LIST',
  },
  GET_SYMBOLOGY_BY_ID: {
    method: 'get',
    apiKeyName: 'GET_SYMBOLOGY_BY_ID',
  },
  CREATE_SYMBOLOGY: {
    method: 'post',
    apiKeyName: 'CREATE_SYMBOLOGY',
  },
  UPDATE_SYMBOLOGY: {
    method: 'put',
    apiKeyName: 'UPDATE_SYMBOLOGY',
  },
  DELETE_SYMBOLOGY: {
    method: 'delete',
    apiKeyName: 'DELETE_SYMBOLOGY',
  },
  UPDATE_SYMBOLOGY_STATUS: {
    method: 'patch',
    apiKeyName: 'UPDATE_SYMBOLOGY_STATUS',
  },
  GENERATE_SIL0_INPUT_FILE: {
    method: 'post',
    apiKeyName: 'GENERATE_SIL0_INPUT_FILE'
  },

  // ===== BEGIN Export-DWG endpoint config =====.
  ADD_ASSET: {
    method: 'post',
    apiKeyName: 'ADD_ASSET'
  },
  ADD_DIVISION: {
    method: 'post',
    apiKeyName: 'ADD_DIVISION',
  },
  ADD_ZONE: {
    method: 'post',
    apiKeyName: 'ADD_ZONE',
  },
  BULK_DELETE_ASSETS: {
    method: 'post',
    apiKeyName: 'BULK_DELETE_ASSETS',
    urlString: 'EXTRACTION_API'
  },
  BULK_UPDATE_BBOXES: {
    method: 'post',
    apiKeyName: 'BULK_UPDATE_BBOXES',
    urlString: 'EXTRACTION_API'
  },
  CREATE_STATION_DETAILS: {
    method:'post',
    apiKeyName:'CREATE_STATION_DETAILS'
  },
  CREATE_STATION_FILES: {
    method:'multipart',
    apiKeyName:'CREATE_STATION_FILES'
  },
  CREATE_VALIDATION_COMMENT: {
    method:'post',
    apiKeyName:'CREATE_VALIDATION_COMMENT'
  },
  DELETE_ADJ_STATIONS: {
    method: 'post',
    apiKeyName: 'DELETE_ADJ_STATIONS',
  },
  DELETE_ASSET: {
    method: 'post',
    apiKeyName: 'DELETE_ASSET'
  },
  DELETE_DIVISION: {
    method: 'post',
    apiKeyName: 'DELETE_DIVISION',
  },
  DELETE_STATION: {
    method: 'post',
    apiKeyName: 'DELETE_STATION',
  },
  DELETE_STATION_DETAILS: {
    method: 'post',
    apiKeyName: 'DELETE_STATION_DETAILS',
  },
  DELETE_STATION_FILE: {
    method:'post',
    apiKeyName:'DELETE_STATION_FILE',
    urlString: 'EXTRACTION_API'
  },
  DELETE_VALIDATION_COMMENT: {
    method:'post',
    apiKeyName:'DELETE_VALIDATION_COMMENT'
  },
  DELETE_ZONE: {
    method: 'post',
    apiKeyName: 'DELETE_ZONE',
  },
  FETCH_QC_REPORT: {
    method: 'post',
    apiKeyName:'FETCH_QC_REPORT',
    postData: {
      report_type: 'QC',
      parameters: {}
    }
  },
  GET_ALL_ASSET_TYPES: {
    method: 'get',
    apiKeyName: 'GET_ALL_ASSET_TYPES',
    urlString: 'EXTRACTION_API',
  },
  GET_ALL_COMMENTS_BY_VALIDATION_UUID: {
    method:'post',
    apiKeyName:'GET_ALL_COMMENTS_BY_VALIDATION_UUID'
  },
  GET_ASSET_BY_FILTERS: {
    method:'post',
    apiKeyName:'GET_ASSET_BY_FILTERS',
    urlString:'EXTRACTION_API'
  },
  GET_DIVISION: {
    method: 'post',
    apiKeyName: 'GET_DIVISION',
  },
  GET_DOCUMENT_TYPES: {
    method: 'get',
    apiKeyName: 'GET_DOCUMENT_TYPES',
    urlString: 'EXTRACTION_API'
  },
  GET_FILE_PROCESS_STATUS: {
    method:'post',
    apiKeyName:'GET_FILE_PROCESS_STATUS'
  },
  GET_MAX_DRAFT_VERSION: {
    method:'post',
    apiKeyName:'GET_MAX_DRAFT_VERSION'
  },
  GET_PROCESSED_VALIDATIONS: {
    method: 'post',
    apiKeyName: 'GET_PROCESSED_VALIDATIONS'
  },
  GENERATE_RFID_LAYOUT: {
    method: 'post',
    apiKeyName: 'GENERATE_RFID_LAYOUT',
    urlString: 'EXTRACTION_API'
  },
  GET_SIGNALING_TOC_TEMPLATES: {
    method:'get',
    apiKeyName:'GET_SIGNALING_TOC_TEMPLATES'
  },
  GET_STATION: {
    method: 'post',
    apiKeyName: 'GET_STATION',
  },
  GET_STATION_DETAILS: {
    method: 'post',
    apiKeyName: 'GET_STATION_DETAILS',
    routerParamsToAdd: {
      queryParams: {
        station_uuid: 'station_uuid',
        station_details_uuid: 'station_details_uuid'
      }
    }
  },
  GET_STATION_FILES: {
    method:'post',
    apiKeyName:'GET_STATION_FILES'
  },
  GET_STREAM_FILE: {
    method:'post',
    apiKeyName:'GET_STREAM_FILE'
  },
  GET_VNV_STREAM_FILE: {
    method: 'post',
    apiKeyName: 'GET_VNV_STREAM_FILE',
    urlString: 'VNV_STREAM_API'
  },
  GET_SURVEY_FILES: {
    method:'get',
    apiKeyName:'GET_SURVEY_FILES'
  },
  GET_TOC_DATA: {
    method:'get',
    apiKeyName:'GET_TOC_DATA'
  },
  GET_TOC_TEMPLATES: {
    method:'get',
    apiKeyName:'GET_TOC_TEMPLATES'
  },
  GET_VALIDATION_RULES: {
    method:'post',
    apiKeyName:'GET_VALIDATION_RULES'
  },
  GET_VALIDATION_SUMMARY: {
    method:'post',
    apiKeyName:'GET_VALIDATION_SUMMARY',
    routerParamsToAdd: {
      queryParams: {
        station_details_uuid: 'station_details_uuid'
      }
    }
  },
  GET_ZONE: {
    method: 'post',
    apiKeyName: 'GET_ZONE',
  },
  PROCESS_SIGNALING_TOC_FILE: {
    method:'multipart',
    apiKeyName:'PROCESS_SIGNALING_TOC_FILE'
  },
  PROCESS_TOC_FILE: {
    method:'multipart',
    apiKeyName:'PROCESS_TOC_FILE'
  },
 REASSOCIATE_ASSETS: {
    method: 'post',
    apiKeyName: 'REASSOCIATE_ASSETS',
    urlString: 'EXTRACTION_API'
  },
  SAVE_TOC_DATA: {
    method:'post',
    apiKeyName:'SAVE_TOC_DATA'
  },
  UPDATE_ASSET: {
    method: 'post',
    apiKeyName: 'UPDATE_ASSET',
    urlString: 'EXTRACTION_API'
  },
  UPDATE_DIVISION: {
    method: 'post',
    apiKeyName: 'UPDATE_DIVISION',
  },
  UPDATE_FILE_PROCESSED_STATUS: {
    method:'post',
    apiKeyName:'UPDATE_FILE_PROCESSED_STATUS'
  },
  UPDATE_STATION: {
    method: 'post',
    apiKeyName: 'UPDATE_STATION',
    routerParamsToAdd: {
    queryParams: {
      station_uuid: 'station_uuid'
    }
  }
  },
  UPDATE_STATION_DETAILS: {
    method: 'post',
    apiKeyName: 'UPDATE_STATION_DETAILS',
  },
  UPDATE_STATION_FILES: {
    method:'multipart',
    apiKeyName:'UPDATE_STATION_FILES'
  },
  UPDATE_VALIDATION_COMMENT: {
    method:'post',
    apiKeyName:'UPDATE_VALIDATION_COMMENT'
  },
  UPDATE_VALIDATION_RULES: {
    method:'post',
    apiKeyName:'UPDATE_VALIDATION_RULES'
  },
  UPDATE_ZONE: {
    method: 'post',
    apiKeyName: 'UPDATE_ZONE',
  },
  VERIFY_VALIDATE: {
    method: 'post',
    apiKeyName: 'VERIFY_VALIDATE',
    routerParamsToAdd: {
      queryParams: {
        station_uuid: 'station_uuid',
        station_details_uuid: 'station_details_uuid'
      }
    }
  },
  GET_TRACKS_BY_STATION: {
    method: 'get',
    apiKeyName: 'GET_TRACKS_BY_STATION',
    urlString: 'EXTRACTION_API'
  }
  // ===== END Export-DWG endpoint config =====
}

